export const searchTags = [
  {
    label: "渋谷・恵比寿",
    groupAreaSlug: "shibuya-ebisu",
    linkPath: null,
    isAreaGroup: true,
  },
  {
    label: "原宿・表参道・青山",
    groupAreaSlug: "harajuku-omotesando-aoyama",
    linkPath: null,
    isAreaGroup: true,
  },
  {
    label: "新宿・代々木",
    groupAreaSlug: "shinjuku-yoyogi-takadanobaba",
    linkPath: null,
    isAreaGroup: true,
  },
  {
    label: "六本木・赤坂・溜池山王",
    groupAreaSlug: "roppongi-akasaka",
    linkPath: null,
    isAreaGroup: false,
  },
  {
    label: "ビジネス",
    linkPath: "/search?ctg=4",
    isAreaGroup: false,
  },
  {
    label: "パーティー・交流会",
    linkPath: "/search?ctg=6",
    isAreaGroup: true,
  },
];
